module.exports = __webpack_public_path__ + "img/islington_roof_ext_b1.46a12551.jpg";